import { RouterModule, Routes } from '@angular/router';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/income-accelerator/income-accelerator.module').then((m) => m.IncomeAcceleratorModule),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
});
